
import { GameState } from '../GameContextTypes';

export const levelUp = (state: GameState): GameState => {
  if (!state.selectedRole) return state;
  
  // Determine the next career level based on current level
  let nextLevel;
  switch (state.careerLevel) {
    case 'Junior':
      nextLevel = 'Mid-Level';
      break;
    case 'Mid-Level':
      nextLevel = 'Senior';
      break;
    case 'Senior':
      nextLevel = 'Leader';
      break;
    case 'Leader':
      nextLevel = 'Expert';
      break;
    default:
      return state; // Already at max level
  }
  
  // Get the career path data for the next level
  const careerLevelData = state.selectedRole.careerPath.find(path => path.level === nextLevel);
  if (!careerLevelData) return state;
  
  // Get title based on career path if path options exist, otherwise use the standard title
  let newTitle = careerLevelData.title;
  
  // If path options exist and the player has chosen a non-standard path, use that title
  if (careerLevelData.pathOptions && state.careerPath !== 'Standard') {
    const pathOption = careerLevelData.pathOptions.find(option => option.path === state.careerPath);
    if (pathOption) {
      newTitle = pathOption.title;
    }
  }
  
  // Add achievement for career advancement
  const achievements = [...state.achievements, `Promoted to ${newTitle}`];
  
  return {
    ...state,
    careerLevel: nextLevel,
    careerTitle: newTitle,
    achievements
  };
};
